<template>
  <div class="cphone-application">
    <div class="table-operations">
      <a-button type="primary" @click="handleRefresh" icon="reload" :loading="loading">
        刷新
      </a-button>
      <a-button type="primary" @click="handleAdd" icon="plus" :loading="loading">
        新增申请
      </a-button>
    </div>
    <a-table :columns="columns" :data-source="dataSource" :pagination="pagination" :loading="loading" rowKey="id"
      @change="handleTableChange" :scroll="{ x: 1300 }">
      <template slot="status" slot-scope="status">
        <a-tag :color="getStatusColor(status)">
          {{ getStatusText(status) }}
        </a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <a-space>
          <a-button type="link" size="small" @click="handleView(record)"
            :disabled="record.status !== 'approved' || record.isshow === '1'">查看号码</a-button>
          <!-- <a-button type="link" size="small" @click="handleEdit(record)"
            v-permission="['admin:cphone:update']">编辑</a-button> -->
          <!-- <a-popconfirm title="确定要删除这条记录吗？" @confirm="handleDelete(record.id)" v-permission="['admin:cphone:delete']">
            <a-button type="link" size="small" danger>删除</a-button>
          </a-popconfirm> -->
        </a-space>
      </template>
    </a-table>

    <!-- Add/Edit Modal -->
    <a-modal :title="modalTitle" v-model="modalVisible" @ok="handleModalOk" @cancel="handleModalCancel"
      :confirmLoading="modalConfirmLoading">
      <a-form-model ref="formRef" :model="formData" :rules="formRules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }">
        <!-- <a-form-model-item label="实例ID" prop="instanceId">
          <a-input v-model="formData.instanceId" placeholder="请输入实例ID" />
        </a-form-model-item>

        <a-form-model-item label="客户ID" prop="customer_id">
          <a-input v-model="formData.customer_id" placeholder="请输入客户ID" />
        </a-form-model-item> -->

        <a-form-model-item label="申请原因" prop="reson">
          <a-textarea v-model="formData.reson" placeholder="请输入申请原因" :rows="4" />
        </a-form-model-item>

        <!-- <a-form-model-item label="状态" prop="status">
          <a-select v-model="formData.status" placeholder="请选择状态">
            <a-select-option value="processing">处理中</a-select-option>
            <a-select-option value="approved">已批准</a-select-option>
            <a-select-option value="rejected">已拒绝</a-select-option>
          </a-select>
        </a-form-model-item> -->

        <!-- <a-form-model-item label="是否显示" prop="isshow">
          <a-radio-group v-model="formData.isshow">
            <a-radio value="0">否</a-radio>
            <a-radio value="1">是</a-radio>
          </a-radio-group>
        </a-form-model-item> -->
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'CPhoneApplication',
  props: {
    customer_id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      columns: [
        // {
        //   title: '实例ID',
        //   dataIndex: 'instanceId',
        //   key: 'instanceId',
        //   //脱敏
        //   customRender: (text) => text.replace(/.(?=.{4})/g, '*'),
        //   width: 120,
        // },
        // {
        //   title: '客户ID',
        //   dataIndex: 'customer_id',
        //   key: 'customer_id',
        // },
        {
          //申请人
          title: '申请人',
          dataIndex: 'userinfo.real_name',
          key: 'userinfo.real_name',
          width: 120,
        },
        {
          title: '申请原因',
          dataIndex: 'reson',
          key: 'reson',
          width: 200,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
          width: 120,
        },
        {
          title: '审批操作时间',
          dataIndex: 'statustime',
          key: 'statustime',
          width: 180,
        },
        {
          title: '是否已查看',
          dataIndex: 'isshow',
          key: 'isshow',
          customRender: (text) => (text === '1' ? '是' : '否'),
          width: 120,
        },
        {
          title: '查看时间',
          dataIndex: 'showtime',
          key: 'showtime',
          width: 180,
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          width: 180,
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right',
        },
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      loading: false,
      modalVisible: false,
      modalTitle: '',
      formData: {
        id: '',
        instanceId: '',
        customer_id: '',
        reson: '',
      },
      formRules: {
        // instanceId: [
        //   { required: true, message: '请输入实例ID', trigger: 'blur' },
        // ],
        customer_id: [
          { required: true, message: '请输入客户ID', trigger: 'blur' },
        ],
        reson: [
          { required: true, message: '请输入申请原因', trigger: 'blur' },
        ]
      },
      modalConfirmLoading: false,
      isEdit: false
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    /// 刷新数据
    handleRefresh() {
      this.pagination.current = 1;
      this.handleTableChange(this.pagination);
    },
    fetchData(params = {}) {
      this.loading = true;

      // Prepare query parameters
      const queryParams = {
        page: params.page || this.pagination.current,
        limit: params.pageSize || this.pagination.pageSize,
        customer_id: this.customer_id || ''
      };

      // Build query string
      const queryString = Object.keys(queryParams)
        .filter(key => queryParams[key] !== '')
        .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
        .join('&');

      this.$http({
        url: `/admin/cphone/page?${queryString}`,
        method: 'get',
      })
        .then(res => {
          if (res.code === 1) {
            this.dataSource = res.data.result;
            this.pagination = {
              ...this.pagination,
              current: parseInt(queryParams.page),
              pageSize: parseInt(queryParams.limit),
              total: res.data.total
            };
          } else {
            this.$message.error(res.msg || '获取数据失败');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      const params = {
        page: pagination.current,
        pageSize: pagination.pageSize
      };
      this.fetchData(params);
    },

    handleAdd() {
      this.isEdit = false;
      this.modalTitle = '新增客户号码查看申请';
      this.formData = {
        id: '',
        instanceId: '',
        customer_id: this.customer_id,
        reson: '',
      };
      this.modalVisible = true;
    },

    handleView(record) {
      //调用/admin/cphone/show会返回{customer_phone: "xxx"}
      this.$http({
        url: '/admin/cphone/show',
        method: 'post',
        data: {
          id: record.id
        }
      })
        .then(res => {
          this.$success({
            title: '客户号码查看成功',
            content: (
              <div>
                <div>客户号码: <span style="color: red;">{res.data.customer_phone}</span></div>
                <div>只可查看一次，确认后将无法再次查看</div>
                <div>申请人：{record.userinfo && record.userinfo.real_name ? record.userinfo.real_name : ''}</div>
                <div>申请时间：{record.statustime}</div>
                <br />
                <p style="color: red;">请勿将客户号码透露给他人，否则后果自负</p>
              </div>
            ),
          });
          this.handleTableChange(this.pagination);
        })
    },

    handleEdit(record) {
      this.isEdit = true;
      this.modalTitle = '编辑客户号码申请';
      this.formData = { ...record };
      this.modalVisible = true;
    },

    handleDelete(id) {
      // Since there's no explicit delete endpoint, we'll use the update endpoint to mark as deleted
      // Or show a message that delete functionality is not available
      this.$http({
        url: '/admin/cphone/update',
        method: 'put',
        data: {
          id,
          status: 'deleted', // Assuming we can mark as deleted by changing status
          statustime: new Date().toISOString()
        }
      })
        .then(res => {
          if (res.data.code === 1) {
            this.$message.success('删除成功');
            this.fetchData();
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        })
    },

    handleModalOk() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.modalConfirmLoading = true;

          const apiMethod = this.isEdit ? 'put' : 'post';
          const apiUrl = this.isEdit ? '/admin/cphone/update' : '/admin/cphone/add';
          const apiData = { ...this.formData };

          // If it's an edit operation, remove userId from the payload since it shouldn't be changed
          if (this.isEdit) {
            delete apiData.userId;
          }

          this.$http({
            url: apiUrl,
            method: apiMethod,
            data: apiData
          })
            .then(() => {
              this.$message.success(`${this.isEdit ? '更新' : '新增'}成功`);
              this.modalVisible = false;
              this.fetchData();
            })
            .finally(() => {
              this.modalConfirmLoading = false;
            });
        }
      });
    },

    handleModalCancel() {
      this.modalVisible = false;
      // Re-enable form inputs if they were disabled for viewing
      setTimeout(() => {
        const inputs = document.querySelectorAll('.ant-input, .ant-select-selector, .ant-input-textarea');
        inputs.forEach(input => {
          input.style.pointerEvents = '';
          input.style.opacity = '';
        });
      }, 100);
    },

    getStatusColor(status) {
      switch (status) {
        case 'approved':
          return 'green';
        case 'reject':
          return 'red';
        case 'processing':
        default:
          return 'orange';
      }
    },

    getStatusText(status) {
      switch (status) {
        case 'approved':
          return '审批通过';
        case 'reject':
          return '审批拒绝';
        case 'processing':
        default:
          return '审批中';
      }
    }
  }
}
</script>

<style scoped>
.cphone-application {
  padding: 20px;
}

.table-operations {
  margin-bottom: 16px;
}

.table-operations>button {
  margin-right: 8px;
}
</style>